export default __webpack_public_path__ + "static/media/cake-2.e7b2b69a.jpg";